<template>
  <div class="justify-content-between">
    <div>
      <h5>{{statuses[completeIdx].toUpperCase()}}</h5>
      <span
        v-if="container.name !== '' &&
        (statuses[completeIdx] === 'Shipping to' || statuses[completeIdx] === 'Arrived in')"
        >
        {{getPort(statuses[completeIdx])}}
      </span>
    </div>
    <div v-if="nextCompleteIdx != completeIdx">
      <b-icon-arrow-down font-scale="2"></b-icon-arrow-down>
    </div>
    <div v-if="nextCompleteIdx != completeIdx">
      <h5 class="text-gray-500">{{statuses[nextCompleteIdx].toUpperCase()}}</h5>
      <span
        v-if="container.name !== '' &&
        (statuses[completeIdx] === 'Shipping to' || statuses[completeIdx] === 'Arrived in')"
        >
        {{getPort(statuses[completeIdx])}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShipmentNextStatus',
  // props: ['currentStatus'],
  props: {
    currentStatus: {
      type: String,
    },
    container: {
      type: Object,
    },
  },
  data() {
    return {
      statusesTypes: [
        { value: 'booked', text: 'Booking Created' },
        { value: 'pickup', text: 'Shipment' },
        { value: 'toload', text: 'Shipping to' },
        { value: 'tooffload', text: 'Arrived in' },
        { value: 'todeliver', text: 'Ready for Delivery' },
        { value: 'completed', text: 'Delivered' },
      ],
      statuses: [
        'Booking Created',
        'Shipment',
        'Shipping to',
        'Arrived in',
        'Ready for Delivery',
        'Delivered',
      ],
    };
  },
  computed: {
    completeIdx() {
      if (!this.currentStatus) {
        return -1;
      }
      let i = -1;
      for (i = 0; i < this.statusesTypes.length; i += 1) {
        if (this.statusesTypes[i].value === this.currentStatus) {
          break;
        }
      }
      return i === this.statuses.length ? 0 : this.statuses.findIndex(
        (status) => status === this.statusesTypes[i].text,
      );
    },
    nextCompleteIdx() {
      if (this.completeIdx === -1) {
        return -1;
      }
      if (this.completeIdx >= this.statuses.length - 1) {
        return this.completeIdx;
      }
      return this.completeIdx + 1;
    },
  },

  methods: {
    getPort(status) {
      if (status === 'Shipping to') {
        if (this.container.destination !== undefined && this.container.destination !== '') {
          return `--- ${this.container.destination}`.toUpperCase();
        }
      }

      if (status === 'Arrived in') {
        let string = '';
        if (this.container.destination !== undefined && this.container.destination !== '') {
          string = string.concat(`--- ${this.container.destination}`);
        }
        if (this.container.unloadingPort !== undefined && this.container.unloadingPort !== '') {
          string = string.concat(` (Port ${this.container.unloadingPort})`);
        }
        return string.toUpperCase();
      }
      return '';
    },
    getPickupType() {
      if (this.shipmentData.pickupDetails.pickupMode !== undefined && this.shipmentData.pickupDetails.pickupMode !== '') {
        const capitalize = this.shipmentData.pickupDetails.pickupMode[0].toUpperCase()
        + this.shipmentData.pickupDetails.pickupMode.slice(1);
        return `${capitalize}`;
      }

      return '';
    },
    getDeliveryType() {
      if (this.shipmentData.itemDetails.shippingTerm !== undefined && this.shipmentData.itemDetails.shippingTerm !== '') {
        const deliverytype = this.deliveryTypes.find(
          (type) => type.value === this.shipmentData.itemDetails.shippingTerm,
        ).text;
        return `(${deliverytype})`.toUpperCase();
      }

      return '';
    },
  },
  filters: {
    capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
  },
};
</script>

<style scoped>
.bg-active {
  background: var(--hover-color);
}

.bg-idle {
  background: var(--accent-color);
}
</style>
